import { PublicService, ObserverService, ListingModalService, ContentService } from '@DavisDigital/davisdigitalfrontend.module';
import { Folder } from '@DavisDigital/interfaces';
import { FolderCardController } from './folder-card';
import { PortfolioListingController } from '@DavisDigital/controllers/portfolio-listing';


class PortfolioFolderCardController extends FolderCardController {

	public portfolio: any;
	public portfolioListing:any;
	public portfolioCount: number;
	public listingController: PortfolioListingController;
	
	public canEdit: boolean = false;
	public sharedBy : string = "";
	public shareText : string = "";
	
	public accountId: string;
	public superUser: boolean;
	
	// @ngInject
	constructor(
		public $filter			    : ng.IFilterService,
		public $window				: ng.IWindowService,
		public publicService	    : PublicService,
		public observerService	    : ObserverService,
		public contentService       : ContentService,
		public listingModalService : ListingModalService
	){
	    super($filter, publicService, observerService, contentService, listingModalService);
	}

	public $onInit = () => {
		this.mapMethodsFromFolder();
	}

    //overriden
	public mapMethodsFromFolder = () => {
		this.title = this.folder.title;
		this.portfolioCount = this.folder.calculatedPortfoliosCount;
		//to handle invalid count case
		if(typeof this.portfolioCount == "string") {
			this.portfolioCount = 0;
		}
		
		
		if( this.folder.createdDateTime.trim() != ""){
			this.createdDateTime = this.$filter('date')(new Date(this.folder.createdDateTime), "MM/dd/yyyy");
		}
		
		var accountAccess = false;
		if( this.folder.hasOwnProperty('accountAccess')) {
			this.sharedBy = this.folder.accountAccess.createdByAccount.firstName+" "+this.folder.accountAccess.createdByAccount.lastName+ ", "+this.folder.accountAccess.createdByAccount.accountRole;
			
			if(this.folder.accountAccess.accountAccessType == "accountAccessWrite") {
				accountAccess = true;
			}
		}
		
		this.canEdit = ( this.folder.account_accountID === this.accountId || this.superUser ) || (accountAccess) || (this.folder.archiveFlag != false);
		this.shareText = this.canEdit ? "Can Edit" : "Can View";
	}
	
	public onViewFolderPortfolios = () => {
        this.listingController.onFolderSelected(this.folder);
    }
	
	/**
	 * Override
	 * */
	public onShare = () => {
	    this.listingModalService.launchShareSettingModal(this.title,this.folder.folderID,'folder', "portfolio");
	}
	
	public onDelete = () => {
	    this.listingModalService.launchDeleteModal(
	        this.title,
	        this.folder.folderID,
	        'folder',
	        (confirmDelete) => {
	        	if( this.folderType == 'sharedPortfolios' || this.folderType == 'myStudentsPortfolios') {
	        		if(this.folder.folderType_systemCode == 'ftMyStudentsPortfolio' ||  this.folder.folderType_systemCode == 'ftMySharedWithMePortfolio'){
	        			this.deleteFolder();
	        		}else{
	        			this.removeAccountAccess();
	        		}
	        	} else {
	        		this.deleteFolder();
	        	}
	        },
	        'folder', // folder-type
	        this.folderType == 'sharedPortfolios' || this.folderType == 'myStudentsPortfolios' ? true : false,
	    );
	}
	
	public onRemove = () => {
	    this.listingModalService.launchDeleteFolderModal(
	        this.title,
	        this.folder.folderID,
		     'folder',
	        (confirmDelete) => {
	        	if( this.folderType == 'sharedPortfolios' && this.folder.folderType_systemCode == 'ftMySharedWithMePortfolio') {
	        		if(this.folder.folderType_systemCode == 'ftMySharedWithMePortfolio'){
	        			this.deleteFolder();
					}else{
	        			this.removeAccountAccess();
	        		}
	        	} else {
	        		this.deleteFolder();
	        	} 
	        	
	        },
	        'portfolio',
	    );
	}
	
	
}

class PortfolioFolderCard {
	public restrict: string = 'E';
	public scope: {};

	public bindToController: any = {
		folder: '=',
		folderType: '=',
		listingController: '=',
		accountId:'@?',
		superUser:'=?'
	};

	public controller = PortfolioFolderCardController;
	public controllerAs = 'portfolioFolderCard';

	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/portfolio-folder-card.html';

	public static Factory() {
		return () => new this();
	}
}

export { PortfolioFolderCard };
